import { ReactNode, FC, CSSProperties, Fragment } from 'react';
import { CustomBackDrop, ModalContainer, ModalContentContainer, ModalHeaderContainer } from './DialogInfo.styles';
import { Box, IconButton, Typography } from '@material-ui/core';
import CloseIcon from 'shared/components/Icon/CloseIcon';

type DialogInfoProps = {
  openDialog: boolean;
  handleDialog: VoidFunction;
  children: ReactNode;
  title: string;
  customStyles?: CSSProperties;
  isSaving?: boolean;
  headerIcon?: ReactNode;
};

const DialogInfo: FC<DialogInfoProps> = ({
  openDialog,
  handleDialog,
  children,
  title,
  customStyles = {},
  headerIcon,
}) => {
  const PAPER_DEFAULT_STYLE = {
    width: '95%',
    maxWidth: '600px',
  };

  return (
    <CustomBackDrop open={openDialog}>
      <ModalContainer
        style={{
          ...PAPER_DEFAULT_STYLE,
          ...customStyles,
        }}
      >
        <ModalHeaderContainer>
          <Box textAlign={'end'}>
            <IconButton
              style={{
                fontSize: 14,
                padding: 7,
                marginRight: -22,
              }}
              onClick={() => {
                handleDialog();
              }}
            >
              <CloseIcon fontSize="inherit" />
            </IconButton>
          </Box>
          {headerIcon ? (
            <Box
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                margin: '10px 0',
                fontSize: 50,
              }}
            >
              {headerIcon}
            </Box>
          ) : (
            <Fragment />
          )}
          <Typography style={{ fontSize: 24, fontWeight: 500, textAlign: 'center' }}>{title}</Typography>
        </ModalHeaderContainer>
        <ModalContentContainer>{children}</ModalContentContainer>
      </ModalContainer>
    </CustomBackDrop>
  );
};

export default DialogInfo;
